import { render, staticRenderFns } from "./lock-screen1.vue?vue&type=template&id=7f35d5f2&"
import script from "./lock-screen1.vue?vue&type=script&lang=js&"
export * from "./lock-screen1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports